/*
 * @Author: zenghao
 * @Date: 2022-04-29 10:02:38
 * @LastEditors: zenghao
 * @LastEditTime: 2022-04-29 10:02:44
 * @Description: 请填写简介
 */
export const ALL_VALUE = '255';
